import { makeVar } from '@apollo/client/cache/inmemory/reactiveVars';

/**
 * Types
 */
import { Course, CourseWithType } from '@/lib/types';

export interface CurrentUser {
  fullName: string;
  email: string;
  userId: string;
  firstName: string;
  lastName: string;
  phone?: string;
}

export const isLoggedInVar = makeVar<boolean>(false);

export const isTourActiveVar = makeVar<boolean>(false);

export const currentUserVar = makeVar<CurrentUser>({
  fullName: '',
  email: '',
  userId: '',
  firstName: '',
  lastName: '',
  phone: ''
});

export const activeJobRoleVar = makeVar<Course | null>(null);
export const activeCourseVar = makeVar<CourseWithType | null>(null);
